import { ymPushEvent } from './ym';
import { CARD_PAYMENT_SUCCESS } from './constants';

// Результат оплаты через GooglePay или ApplePay (успех или ошибка)
export const pushResult = (type, result) => {
  window.dataLayer.push({
    event: 'event_az_applForm',
    eventAction: `pay_${result}_${type}Pay`,
    formName: 'Пополнение счёта',
  });
};

// Результат успешной оплаты для YM
export const sendAnalyticsOnPaymentSuccess = (sum) => {
  ymPushEvent(
    CARD_PAYMENT_SUCCESS,
    // eslint-disable-next-line camelcase
    { order_price: sum, currency: 'RUB' },
  );
};

// Клик на кнопку GooglePay / ApplePay
export const pushClickPayButton = (buttonType) => {
  window.dataLayer.push({
    event: 'tap_so_detail',
    action: 'buttonClick',
    eventText: buttonType,
  });
};
